/* widget config: label + widget name */
export const h2h = { label: 'H2H', name: 'h2h' }

export const h2hNew = { label: 'H2H(New)', name: 'h2hNew' }

export const h2hIntegration = {
  label: 'H2H',
  name: 'h2hIntegration',
  component: () => import('@ms/components/matchDetail/H2HIntegration.vue')
}

export const mStats = {
  label: 'M Stats',
  name: 'mStats',
  component: () => import('@ms/components/matchDetail/MStats/index.vue')
}

export const comparison = { label: 'Comparison', name: 'comparison' }

export const standings = { label: 'Standings', name: 'standings' }

export const tracker = { label: 'Tracker', name: 'lmtPlus' }

export const preview = { label: 'Preview', name: 'preview' }

export const momentum = { label: 'Momentum', name: 'momentum' }

export const generalStatistics = { label: 'General Statistics', name: 'generalStatistics' }

export const lineups = { label: 'Lineups', name: 'lineups' }

export const liveTable = { label: 'Live Table', name: 'liveTable' }

export const basketballHeatmap = { label: 'Heat Map', name: 'basketballHeatmap' }

export const table = { label: 'Table', name: 'liveTable' }

export const distributionOfGoals = {
  label: 'Distribution of Goals',
  component: () => import('@ms/components/matchDetail/DistributionOfGoals/index.vue'),
  name: 'distributionOfGoals'
}
